import {DRIVER_INSIGHTS_PAGE} from '../Constants/driverInsightsPage'

export const fetchDriverInsightsPageInfo = (params) => ({
    type: DRIVER_INSIGHTS_PAGE.DRIVER_INSIGHTS_PAGE_FETCH,
    payload: params
});
  